const constants = {
  DISPLAY_PANEL: 'DISPLAY_PANEL',
};

export default constants;
